import { FeatureFlagsEnum } from "../Api";
import { useQuery } from "react-query";
import { getFeatureFlags } from "../Requests/feedback-feature-flags-requests";

export const featureFlagsQuery = "featureFlags";

export const useFeatureFlagLists = () => {
	return useQuery([featureFlagsQuery], () => getFeatureFlags(), {
		refetchOnWindowFocus: false,
		refetchInterval: 5 * 60 * 1000,
	});
};

export const featureFlagTypeKeys = Object.keys(FeatureFlagsEnum).map(
	(e) => FeatureFlagsEnum[e as keyof typeof FeatureFlagsEnum]
);

export const useFeatureFlags = () => {
	const { data, isLoading } = useFeatureFlagLists();

	return featureFlagTypeKeys.reduce((acc, x) => {
		return {
			...acc,
			[`is${x}`]: isLoading
				? undefined
				: data?.some((e) => e.value && e.featureFlag === x) ?? false,
		};
	}, {} as { [K in keyof typeof FeatureFlagsEnum as `is${K & string}`]: boolean | undefined });
};
